const validateRegistBackNo = (numbers: any) => {
  if (numbers.match('[^0-9]')) {
    console.error('validateRegistBackNo - numbers must have only numbers');
    return false;
  }
  if (numbers.length !== 13) {
    console.error('validateRegistBackNo - numbers must have 13 elements');
    return false;
  }
  const multipliers = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];

  const sum = multipliers.reduce((prev, current, currentIndex) => {
    return prev + current * numbers[currentIndex];
  }, 0);
  const isForeigner = [5, 6, 7, 8].includes(Number(numbers[6]));
  const initNumber = isForeigner ? 13 : 11;
  const checkNumber = Number(numbers[numbers.length - 1]);

  return (initNumber - (sum % 11)) % 10 === checkNumber;
};

const validateCarNo = (str: string) => {
  if (/^\d{2}[가-힣]\d{4}/.exec(str) !== null && str.length === 7) {
    return true;
  }

  if (/^\d{3}[가-힣]\d{4}/.exec(str) !== null && str.length === 8) {
    return true;
  } // todo 파악 후 로직 정리 (ex if문 하나로?)

  return false;
};

const validateAllChecked = (v: any) => {
  return v.every((item: boolean) => item);
};

const validateNumString = (v: string) => {
  const str = v.replace(/,/g, '');
  const reg = /^[0-9]+$/;
  const numberCheckReg = /\d/;
  return reg.test(str) || numberCheckReg.test(v) || str === ''
    ? true
    : console.log('숫자만 입력해주세요');
};

const getDateKorea = (date?: string) => {
  const curr = date ? new Date(date) : new Date();

  // 2. UTC 시간 계산
  const utc = curr.getTime() + curr.getTimezoneOffset() * 60 * 1000;

  // 3. UTC to KST (UTC + 9시간)
  const KR_TIME_DIFF = 9 * 60 * 60 * 1000;
  const kr_curr = new Date(utc + KR_TIME_DIFF);

  return {
    year: kr_curr.getFullYear(),
    month: kr_curr.getMonth() + 1,
    date: kr_curr,
  };
};

const validateYearMonth = ({
  year,
  month,
}: {
  year: string | number;
  month: string | number;
}) => {
  const maxDate = new Date();
  const minDate = new Date('1920-01');
  const theDate = new Date(`${year}-${month}`);
  return !isNaN(Number(theDate)) && minDate <= theDate && theDate <= maxDate;
};

const validateYearMonthDay = ({
  year,
  month,
  day,
}: {
  year?: string | number;
  month?: string | number;
  day?: string | number;
}) => {
  const maxDate = new Date();
  const minDate = new Date('1900-01-01');
  const theDate = new Date(`${year}-${month}-${day}`);
  return !isNaN(Number(theDate)) && minDate <= theDate && theDate <= maxDate;
};

export {
  // todo naming return boolean 이면 is___로 변경하기
  validateCarNo,
  validateRegistBackNo,
  validateAllChecked,
  validateNumString,
  validateYearMonth,
  validateYearMonthDay,
};
